import type { MechKey } from './keys';

export const nl: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mechanica · 2D',
  'panel.scene': 'Scène',
  'panel.dims': 'Parameters',
  'panel.style': 'Uiterlijk',
  'panel.action': 'Besturing',
  'style.body': 'Lichaam',
  'style.vector': 'Vectoren',
  'style.ground': 'Grond',
  'style.forces': 'Krachten tonen',
  'style.trace': 'Spoor tonen',
  'style.labels': 'Vectorlabels',
  'hint.line1': 'Klik op afspelen om te starten · sleep lichamen om ze te verplaatsen',
  'hint.line2': 'Sandbox: kies een vorm, klik dan om te plaatsen',
  'scene.incline': 'Hellend vlak',
  'scene.projectile': 'Projectielbeweging',
  'scene.pendulum': 'Slinger',
  'scene.springMass': 'Veer-massa systeem',
  'scene.collisions': 'Botsingen',
  'scene.atwood': 'Machine van Atwood',
  'scene.circular': 'Cirkelvormige beweging',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'hoek (°)',
  'dim.friction': 'wrijving',
  'dim.mass': 'massa',
  'dim.massA': 'massa A',
  'dim.massB': 'massa B',
  'dim.velocity': 'snelheid',
  'dim.angleLaunch': 'lanceerhoek (°)',
  'dim.gravity': 'zwaartekracht',
  'dim.gravityX': 'zwaartekracht x',
  'dim.gravityY': 'zwaartekracht y',
  'dim.length': 'lengte',
  'dim.damping': 'demping',
  'dim.spring': 'stijfheid',
  'dim.restitution': 'restitutie',
  'dim.radius': 'straal',
  'dim.speed': 'snelheid',
  'action.play': 'Afspelen',
  'action.pause': 'Pauzeren',
  'action.step': 'Stap',
  'action.reset': 'Herstellen',
  'action.speed': 'Snelheid',
  'action.clear': 'Wissen',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Zwaartekracht',
  'forceName.normal': 'Normaalkracht',
  'forceName.friction': 'Wrijvingskracht',
  'forceName.tension': 'Spanning',
  'forceName.spring': 'Veerkracht',
  'forceName.applied': 'Toegepaste kracht',
  'forceName.air': 'Luchtweerstand',
  'palette.box': 'Doos',
  'palette.circle': 'Bal',
  'palette.ramp': 'Helling',
  'palette.ground': 'Grond',
  'palette.hint': 'Kies een vorm, klik dan op het canvas om te plaatsen.',
  'panel.forces': 'Waargenomen krachten',
  'forces.empty': 'Nog geen — speel de scène af',
};
